var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoteSingleOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 42 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.074 8.566-6.232-5.744C30.485 1.571 27.804.548 25.885.548H4.948c-1.92 0-3.489 1.448-3.489 3.216v34.735c0 1.769 1.571 3.216 3.489 3.216h32.105c1.92 0 3.489-1.448 3.489-3.216V14.055c0-1.769-1.111-4.239-2.468-5.489m-1.973 1.819c.136.125.272.28.405.455h-7.13V4.268c.189.122.357.247.493.373zm1.649 28.114c0 .349-.32.643-.698.643H4.948c-.379 0-.698-.295-.698-.643V3.764c0-.349.32-.643.698-.643h20.938c.211 0 .448.025.698.069v10.223h11.092c.048.231.074.449.074.643z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.627 21.296 18.122 32.184H13.86v-4.033l11.505-10.887zm1.438-1.361-4.261-4.033 1.493-1.413a1.333 1.333 0 0 1 1.808 0l2.453 2.321a1.17 1.17 0 0 1 0 1.711zm-3.569 7.097v8.377H10.452V19.28h9.375l3.409-3.226H9.6c-1.406 0-2.557 1.089-2.557 2.42v17.742c0 1.331 1.151 2.42 2.557 2.42h18.749c1.406 0 2.557-1.089 2.557-2.42v-12.08z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoteSingleOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note-single-off.svg";